'use client';
import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircleIcon } from '@heroicons/react/24/solid';

const benefits = [
    'Global logistics network with local expertise',
    'Advanced tracking and monitoring systems',
    'Custom solutions for your business needs',
    'Experienced and dedicated team',
    'Competitive pricing and flexible options',
    'Sustainable and eco-friendly practices'
];

const WhyChooseUs = () => {
    return (
        <section className="py-20 bg-[var(--background-light)]">
            <div className="max-w-7xl mx-auto container-padding">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                    <div className="relative h-[500px] rounded-2xl overflow-hidden">
                        <img
                            src="/images/logistics-warehouse.jpg"
                            alt="Modern Logistics Warehouse"
                            className="w-full h-full object-cover"
                        />
                        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent h-1/3"></div>
                        <div className="absolute bottom-6 left-6 right-6 text-white">
                            <div className="text-sm font-semibold text-[var(--primary-color)]">Trusted by Industry Leaders</div>
                            <div className="text-2xl font-bold mt-2">15+ Years of Excellence in Logistics</div>
                        </div>
                    </div>

                    <div className="animate__animated animate__fadeInRight">
                        <h2 className="heading-secondary mb-6">
                            Why Leading Businesses Choose us
                        </h2>
                        <p className="text-lg text-[var(--text-secondary)] mb-8">
                            We combine industry expertise, innovative technology, and personalized service
                            to deliver exceptional logistics solutions that help your business thrive.
                        </p>

                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                            {benefits.map((benefit, index) => (
                                <div 
                                    key={index} 
                                    className="flex items-start space-x-3 animate__animated animate__fadeInUp"
                                    style={{ animationDelay: `${index * 0.1}s` }}
                                >
                                    <CheckCircleIcon className="h-6 w-6 text-[var(--primary-color)] flex-shrink-0" />
                                    <span className="text-[var(--text-primary)]">{benefit}</span>
                                </div>
                            ))}
                        </div>

                        <div className="mt-10 space-y-4 sm:space-y-0 sm:space-x-4 flex flex-col sm:flex-row">
                            <Link 
                                to="/contact" 
                                className="btn-primary text-center"
                            >
                                Get Started
                            </Link>
                            <Link 
                                to="/about" 
                                className="btn-secondary text-center"
                            >
                                Learn More
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default WhyChooseUs; 